import React from "react";
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";

const RangeSlider = ({
  getRangeValue,
  onAfterChangeInterval,
  numberInterval,
  timeInterval
}) => {
  const offsetHandle = ({ offset, style, className }) => {
    if (className === "rc-slider-handle rc-slider-handle-2") {
      return (
        <div
          key={1}
          className="rc-slider-handle rc-slider-handle-2"
          style={{
            ...style,
            left: `calc(${offset}% + 10px)`
          }}
        >
          {timeInterval[1]}
        </div>
      );
    } else {
      return (
        <div
          key={0}
          className="rc-slider-handle rc-slider-handle-1"
          style={{
            ...style,
            left: `calc(${offset}% - 45px)`
          }}
        >
          {timeInterval[0]}
        </div>
      );
    }
  };

  return (
    <div style={rangeContainer}>
      <Range
        allowCross={false}
        pushable={false}
        handle={offsetHandle}
        railStyle={railStyle}
        trackStyle={[trackStyle]}
        handleStyle={[handleStyle, { ...handleStyle }]}
        defaultValue={numberInterval}
        min={numberInterval[0]}
        max={numberInterval[1]}
        step={1}
        style={{
          marginLeft: `55px`,
          maxWidth: "calc(100% - 110px)",
          boxSizing: "border-box",
          padding: "0"
        }}
        onChange={e => getRangeValue(e)}
        onAfterChange={e => onAfterChangeInterval(e)}
      />
    </div>
  );
};

export default RangeSlider;

const rangeContainer = {
  background: "rgba(29, 103, 136, 0.1)",
  height: "30px",
  borderRadius: "5px",
  maxWidth: "100%",
  boxSizing: "border-box"
};

const handleStyle = {
  width: "55px",
  height: "30px",
  background: "#f4f4f4",
  color: "#2B2B2B",
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "normal",
  lineHeight: "normal",
  fontSize: "14px",

  borderRadius: "5px",
  border: "2px solid hsla(240, 6%, 75%, 0.5)",

  marginTop: "0",
  marginLeft: "-10px",

  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

const railStyle = {
  background: "transparent",
  height: "30px",
  maxWidth: "100%",

  boxSizing: "border-box"
};

const trackStyle = {
  background: "#f4f4f4",
  height: "30px",
  borderRadius: "0"
};



// WEBPACK FOOTER //
// ./src/components/Events/RangeSlider.js